import { MyReactSelectOptionType, OnChange } from '@/components/Dropdown';
import { NetworkType, WalletType } from '@/interfaces/IUser';
import { authNetworkType, authWalletType, setNetworkId, setNetworkType, userLoggedStatus } from '@/redux/auth';
import { ArrayElement } from '@/types/ArrayElement.type';
import { capitalizeFirstLetter } from '@/utils/functions';
import { useAppDispatch, useAppSelector } from '@/utils/hooks';
import React, { useEffect, useState } from 'react';
import {
  components,
  GroupBase,
  OptionProps,
  ValueContainerProps,
} from 'react-select';
import {
  IconContainer,
  StyledContainer,
  StyledEthIcon,
  StyledPolygonIcon,
  StyledUnsupportedNetworkIcon,
  StyledSelect,
} from './styled';
import { changeNetwork, getWalletConnectProvider, getWeb3 } from '../../../../web3/getWeb3'
import { config } from '@/sahara-core-config';
import Web3 from 'web3';

type Option = NetworkType;

const options: MyReactSelectOptionType<Option>[] = [
    {
    value: NetworkType.UNSUPPORTED,
    label: capitalizeFirstLetter(NetworkType.UNSUPPORTED) as NetworkType,
    icon: StyledUnsupportedNetworkIcon as string,
    isDisabled: true,
    chainID: '0x00'
  },
  {
    value: NetworkType.POLYGON,
    label: capitalizeFirstLetter(NetworkType.POLYGON) as NetworkType,
    icon: StyledPolygonIcon as string,
    isDisabled: false,
    chainID: '0x89'
  },
  // {
  //   value: NetworkType.MUMBAI,
  //   label: capitalizeFirstLetter(NetworkType.MUMBAI) as NetworkType,
  //   icon: StyledPolygonIcon as string,
  //   isDisabled: false,
  //   chainID: '0x13881'
  // },
  {
    value: NetworkType.ROPSTEN,
    label: capitalizeFirstLetter(NetworkType.ROPSTEN) as NetworkType,
    icon: StyledEthIcon as string,
    isDisabled: false,
    chainID: '0x3'
  },
  {
    value: NetworkType.MAINNET,
    label: capitalizeFirstLetter(NetworkType.MAINNET) as NetworkType,
    icon: StyledEthIcon as string,
    isDisabled: false,
    chainID: '0x1'
  }
  // {
  //   value: NetworkType.TRON,
  //   label: capitalizeFirstLetter(NetworkType.TRON) as NetworkType,
  // },
];

type OptionsElement = ArrayElement<MyReactSelectOptionType<Option>[]>;

function CustomOption(
  props: OptionProps<
    MyReactSelectOptionType,
    boolean,
    GroupBase<MyReactSelectOptionType>
  >
) {
  return (
    <components.Option {...props}>
      {props.data.icon && <props.data.icon />}
      {props.data.label}
    </components.Option>
  );
}

const ValueContainer = ({
  children,
  ...props
}: ValueContainerProps<
  MyReactSelectOptionType,
  boolean,
  GroupBase<MyReactSelectOptionType>
>) => {
  const [currentValue] = props.getValue() as OptionsElement[];
  return (
    components.ValueContainer && (
      <components.ValueContainer {...props}>
        {!!children && currentValue.icon && (
          <IconContainer>
            {currentValue.icon && <currentValue.icon />}
          </IconContainer>
        )}
        {children}
      </components.ValueContainer>
    )
  );
};

const selectCurrentValueFromOptions = function (
  type: NetworkType
): MyReactSelectOptionType {
  return options.find(({ value }) => value === type) as MyReactSelectOptionType;
};


export default function GoComponent(): JSX.Element {
  const dispatch = useAppDispatch();
  const networkType = useAppSelector(authNetworkType);
  const walletType = useAppSelector(authWalletType);
  const userStatus = useAppSelector(userLoggedStatus);

  const [currentNetworkType, setCurrentNetworkType] = useState(networkType);
  
  useEffect(() => {
    (async function fetch() {
      if(userStatus == 'auth'){
        const web3 = (walletType === WalletType.WALLETCONNECT) ? await new Web3(await getWalletConnectProvider()) : await getWeb3();
        if(web3){
          const netId = await web3.eth.net.getId();
          setCurrentNetworkType(getNetworkType(netId));
        } 
        // else {
        //   setCurrentNetworkType(networkType);
        // }
      }

    })();
  }, []);

  function getNetworkType(networkId : number) : NetworkType{
    let networkType = 'unsupported';
    if(config.deployments[networkId]){
      networkType = config.deployments[networkId].networkName;
    } 
    return networkType as NetworkType;
  }
  

  const generalOnChange: OnChange<MyReactSelectOptionType> = async (option) => {
    //TODO: implement changes when there will be new networks
    if (option) {
      const chainID : any = option.chainID;
      const netId = parseInt(chainID, 16);
      const NetworkType = getNetworkType(parseInt(chainID, 16));

      dispatch(setNetworkType(NetworkType as NetworkType));
      setCurrentNetworkType(NetworkType);
      dispatch(setNetworkId(netId));
      if(walletType == WalletType.METAMASK){
        await changeNetwork(chainID, netId);
      }
      // window.location.reload();
    }
  };

  return (
    <StyledContainer>
      <StyledSelect
        options={options.filter(type => type.value != NetworkType.UNSUPPORTED)}
        onChange={generalOnChange as OnChange<unknown>}
        // defaultValue={selectCurrentValueFromOptions(currentNetworkType)}
        value={selectCurrentValueFromOptions(currentNetworkType)}
        isSearchable={false}
        components={{
          Option: CustomOption as typeof components.Option,
          ValueContainer: ValueContainer as typeof components.ValueContainer,
        }}
      />
    </StyledContainer>
  );
}
